import React from "react";
import PaymentOptions from "./PaymentOptions";
import PaymentPrompt from "./PaymentPrompt";

interface Props {
  setOpen: (value: boolean) => void;
  cost: number | undefined;
  currency: string | undefined;
}

const Index = ({ setOpen, cost, currency }: Props) => {
  const [step, setStep] = React.useState<number>(1);

  return (
    <div>
      {step === 1 && (
        <PaymentPrompt
          cost={cost}
          step={step}
          setStep={setStep}
          setOpen={setOpen}
          currency={currency}
        />
      )}
      {step === 2 && <PaymentOptions setOpen={setOpen} cost={cost} />}
    </div>
  );
};

export default Index;
